<div class="lvi-content">
    <div class="avatar">
        <i class="nio icon-profil"></i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a>{{ data.user | user }}</a>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.entreprise.populations.usage.service'"></strong>
                <span>{{ data.user | user:'orga' }}</span>
            </li>
            <li>
                <strong [translate]="'admin.entreprise.populations.usage.role'"></strong>
                <!-- Ce span peut être surprenant mais on a pas d'autres valeurs -->
                <span>COL</span>
            </li>
        </ul>
    </div>
</div>